<div class="solving-progress bg-primyellow p-6 ms-auto d-flex">
  <div class="me-5">
    <circle-progress [title]="currentTime" [titleColor]="'#000'" [titleFontSize]="'16px'" [titleFontWeight]="'bold'"
      [radius]="32" [percent]="timerWidth" [outerStrokeWidth]="8" [outerStrokeColor]="'#000'" [innerStrokeWidth]="8"
      [innerStrokeColor]="'#fff'" [space]="-8" [showUnits]="false" [showSubtitle]="false" [showBackground]="false"
      [startFromZero]="false" [animation]="true" [renderOnClick]="false"></circle-progress>
  </div>
  <div class="flex-1">
    <ng-template [ngIf]="isVipSubscription">
      <p class="mb-3 px-5 py-3 bg-primblack rounded-1 text-white solving-progress__status">
        <span *ngIf="ticketStatus === 'waiting_for_lock'">
          Looking&nbsp;for&nbsp;an&nbsp;expert:
        </span>
        <span *ngIf="ticketStatus === 'waiting_for_solve'">
          Solving&nbsp;your&nbsp;task:
        </span>
      </p>
      <p class="mb-0 text-primblack h3">
        <span *ngIf="ticketStatus === 'waiting_for_lock'">
          {{(timeToLock?.time_to_lock_for_user_real / 60) | number: '1.0-0'}} mins
        </span>
        <span *ngIf="ticketStatus === 'waiting_for_solve'">
          {{(timeToSolve?.time_to_solve_for_user_real / 60) | number: '1.0-0'}} mins
        </span>
      </p>
    </ng-template>
    <ng-template [ngIf]="!isVipSubscription">
      <p class="h6 text-black mb-3 solving-progress__status">
        <span *ngIf="ticketStatus === 'waiting_for_lock'">
          Looking&nbsp;for&nbsp;an&nbsp;expert:
        </span>
        <span *ngIf="ticketStatus === 'waiting_for_solve'">
          Solving&nbsp;your&nbsp;task:
        </span>
        <span class="px-3 py-1 bg-primsalad text-nowrap rounded-1">
          <ng-template [ngIf]="ticketStatus === 'waiting_for_lock'">
            {{(timeToLock?.time_to_lock_for_user_real / 60) | number: '1.0-0'}} mins
          </ng-template>
          <ng-template [ngIf]="ticketStatus === 'waiting_for_solve'">
            {{(timeToSolve?.time_to_solve_for_user_real / 60) | number: '1.0-0'}} mins
          </ng-template>
        </span>
      </p>
      <button type="button"
        class="btn app-btn-black btn-outline w-100 py-3 d-flex align-items-center justify-content-center"
        (click)="openVipComponent()">
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="me-4">
          <g clip-path="url(#clip0_3653_12417)">
            <path
              d="M20.2749 7.05519C20.0866 6.90788 19.8277 6.88991 19.6208 7.00952L14.7575 9.82124L11.0048 3.45254C10.8995 3.27379 10.7075 3.16406 10.5 3.16406C10.2925 3.16406 10.1005 3.27379 9.99515 3.45254L6.24254 9.82124L1.37923 7.00952C1.17224 6.88991 0.913373 6.90792 0.725092 7.05519C0.536772 7.20241 0.456772 7.44925 0.522905 7.67894L3.03767 16.4121C3.10993 16.6631 3.33958 16.836 3.60071 16.836H17.3993C17.6604 16.836 17.8901 16.6631 17.9623 16.4121L20.4771 7.67894C20.5433 7.44925 20.4633 7.20241 20.2749 7.05519ZM16.9583 15.6641H4.04177L3.20341 12.7527L6.57321 14.701C6.78758 14.8249 7.05676 14.8007 7.24559 14.6404L10.5 11.8789L13.7544 14.6404C13.9429 14.8004 14.2121 14.8251 14.4268 14.701L17.7966 12.7527L16.9583 15.6641ZM18.2643 11.1287L14.1978 13.4797L10.8791 10.6636C10.6605 10.4781 10.3396 10.4781 10.1209 10.6636L6.80227 13.4797L2.73575 11.1287L2.0513 8.75171L6.15911 11.1266C6.43758 11.2876 6.79387 11.194 6.95719 10.9168L10.5 4.90422L14.0429 10.9168C14.2062 11.194 14.5624 11.2876 14.841 11.1266L18.9487 8.75171L18.2643 11.1287Z"
              fill="currentColor" />
          </g>
          <defs>
            <clipPath id="clip0_3653_12417">
              <rect width="20" height="20" fill="white" transform="translate(0.5)" />
            </clipPath>
          </defs>
        </svg>
        <span>
          Get Priority
        </span>
      </button>
    </ng-template>
  </div>
</div>
